module.exports = __webpack_public_path__ + "media/images/search_icon-6ffcf7b9.svg";